import React from "react";

import Search from "./Search";
import Typography from "@material-ui/core/Typography";

export default class extends React.Component {
  render() {
    const title = this.props.title || null;
    const hasSearch = this.props.hasSearch || false;

    if (!title) {
      return null;
    }

    return (
      <div className="header">
        <Typography variant="h6" component="h6">
          {title}
        </Typography>

        {hasSearch && <Search {...this.props} />}
      </div>
    );
  }
}
